import { ref } from "vue";

const showMoreDialog = ref(false);

export function useShowMoreDialog() {
  return showMoreDialog;
}
